import { EntityClient } from "../../entity/EntityClient";

export class DtoClientsPutRes extends EntityClient {}
